/* Carousel dots that tell the truth.

   Impact hides the dots with `peer-not-scrollable:hidden`, which compiles to
       :not(.is-scrollable) ~ .peer-not-scrollable\:hidden { display: none }
   so the dots follow the `is-scrollable` class on the carousel. theme.js sets
   that class once, from `scrollDirection`, and never recalculates it when the
   viewport changes. Measured on the live homepage stats row, 2026-09-09:

     load at 1440, resize to 390   scrollWidth 1560 vs clientWidth 390
                                   is-scrollable false, dots HIDDEN
                                   (it scrolls, with no indicator)
     load at 390, resize to 1440   scrollWidth 650 vs clientWidth 650
                                   is-scrollable true, dots SHOWN
                                   (Joe's report: dots that scroll nothing)

   So the indicator was wrong in both directions, depending only on the width
   the page happened to load at. This re-measures and corrects the class, which
   lets the theme's own CSS resolve correctly - rather than overriding
   `display` on the dots, which loses to that rule anyway.

   Affects every section using page-dots: press, shop-the-look, slideshow,
   text-with-icons and timeline. */
(function () {
  'use strict';

  function sync() {
    var dots = document.querySelectorAll('page-dots');
    for (var i = 0; i < dots.length; i++) {
      var parent = dots[i].parentElement;
      if (!parent) continue;
      var car = parent.querySelector('scroll-carousel');
      if (!car) continue;
      /* one pixel of slack: sub-pixel rounding otherwise reads as overflow on
         a row that visibly fits */
      car.classList.toggle('is-scrollable', car.scrollWidth > car.clientWidth + 1);
    }
  }

  sync();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  }
  /* Web fonts land after first paint and change the row width, so measure
     again once everything has settled. */
  window.addEventListener('load', sync);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sync);
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(sync, 150);
  });

  /* sections re-render as blocks are edited in the theme editor */
  document.addEventListener('shopify:section:load', sync);
})();
